import { Dispatch, JSX, SetStateAction } from 'react';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid';

/** Types */
export type InputPasswordType = 'password' | 'text';
export type InputPasswordIcons = {
  [key in InputPasswordType]: JSX.Element;
};

/** Password Icons */
export const passwordVisibilityIcons: InputPasswordIcons = {
  password: <EyeIcon className="size-5 text-ink-light" />,
  text: <EyeSlashIcon className="size-5 text-ink-medium" />,
};

/**
 * @description Toggle password visibility. It toggles the password visibility between 'password' and 'text'.
 * - `stateSetter`: The state setter function to update the password visibility state.
 */
export const togglePasswordVisibility = (stateSetter: Dispatch<SetStateAction<InputPasswordType>>) => {
  stateSetter((prev) => (prev === 'password' ? 'text' : 'password'));
};
